import { useNavigate } from "react-router-dom";

// --- core fetch wrapper ---
export async function apiFetch(token, url, options = {}) {
  try {
    const res = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });

    if (res.status === 401 || res.status === 403) {
      console.warn("Auth failed, clearing cache and redirecting to login…");
      // Clear MSAL cache to force fresh login
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`API error ${res.status}: ${text}`);
    }
    return res.json();
  } catch (err) {
    console.error("API call failed:", err);
    throw err;
  }
}


export async function apiFetchNoRedirect(token, url, options = {}) {
  try {
    const res = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`API error ${res.status}: ${text}`);
    }
    return res.json();
  } catch (err) {
    console.error("API call failed:", err);
    throw err;
  }
}
